import React, { useState, useEffect } from 'react';
import { Calendar } from 'lucide-react';
import { reportsAPI } from '../services/api';

const FYPicker = ({ value, onChange, className = '' }) => {
  const [years, setYears] = useState([]);
  const [currentFY, setCurrentFY] = useState('');

  useEffect(() => {
    reportsAPI.getFinancialYears()
      .then(res => {
        setYears(res.data.financialYears || []);
        setCurrentFY(res.data.currentFY || '');
      })
      .catch(() => {});
  }, []);

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Calendar className="w-4 h-4 text-gray-400 flex-shrink-0" />
      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value || null)}
        className="appearance-none bg-white border border-brand-100 rounded-xl px-3 py-2 pr-8 text-sm font-medium text-brand-900 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500 cursor-pointer"
      >
        <option value="">All Years</option>
        {years.map(fy => (
          <option key={fy} value={fy}>
            FY {fy}{fy === currentFY ? ' (Current)' : ''}
          </option>
        ))}
      </select>
    </div>
  );
};

export default FYPicker;
